const svgLogoDataUri = (label, bg = '#111827', fg = '#ffffff') => {
  const safeLabel = String(label || '').slice(0, 4).toUpperCase();
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
      <defs>
        <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stop-color="${bg}" stop-opacity="1"/>
          <stop offset="1" stop-color="#000000" stop-opacity="0.22"/>
        </linearGradient>
      </defs>
      <rect width="512" height="512" rx="128" fill="url(#g)"/>
      <circle cx="256" cy="256" r="170" fill="rgba(255,255,255,0.08)"/>
      <text x="50%" y="54%" dominant-baseline="middle" text-anchor="middle"
        font-family="ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial"
        font-size="140" font-weight="800" fill="${fg}" letter-spacing="6">${safeLabel}</text>
    </svg>
  `.trim();
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};

export const DUMMY_RESTAURANTS = [
  {
    _id: 'idylll-indiranagar-blr',
    name: 'Idylll - Indian Plates & Cocktails',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'Modern Indian • North Indian • South Indian • Seafood • Kebabs',
    address: 'Plot No. 608, 12th Main Rd, HAL 2nd Stage, Indiranagar, Bengaluru, Karnataka 560038',
    openingTime: '12:00 PM',
    closingTime: '1:00 AM',
    image: 'https://b.zmtcdn.com/data/pictures/2/21245002/5be3363105087f4fc890953e769a764d.jpg?fit=around|750:500&crop=750:500;*,*',
    logo: svgLogoDataUri('IDYL', '#0f172a', '#f8fafc'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kormangala-smokehouse-blr',
    name: 'Koramangala Smokehouse',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'BBQ • Grills • Continental',
    address: '80 Feet Road, Koramangala 4th Block, Bengaluru, Karnataka 560034',
    openingTime: '12:00 PM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/kormangala-smokehouse-blr-cover/1600/900',
    logo: svgLogoDataUri('KSH', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'church-street-bistro-blr',
    name: 'Church Street Bistro',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'Italian • Cafe • Desserts',
    address: 'Brigade Road, Near Church Street, Bengaluru, Karnataka 560001',
    openingTime: '9:00 AM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/church-street-bistro-blr-cover/1600/900',
    logo: svgLogoDataUri('CSB', '#1d4ed8', '#eff6ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'indiranagar-dosa-club-blr',
    name: 'Indiranagar Dosa Club',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'South Indian • Breakfast',
    address: '100 Feet Road, Indiranagar, Bengaluru, Karnataka 560038',
    openingTime: '8:00 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/indiranagar-dosa-club-blr-cover/1600/900',
    logo: svgLogoDataUri('IDC', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'whitefield-wok-story-blr',
    name: 'Whitefield Wok Story',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'ITPL Main Road, Whitefield, Bengaluru, Karnataka 560066',
    openingTime: '12:00 PM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/whitefield-wok-story-blr-cover/1600/900',
    logo: svgLogoDataUri('WWS', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'jayanagar-thali-house-blr',
    name: 'Jayanagar Thali House',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'North Indian • Thali • Vegetarian',
    address: '4th Block, Jayanagar, Bengaluru, Karnataka 560011',
    openingTime: '11:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/jayanagar-thali-house-blr-cover/1600/900',
    logo: svgLogoDataUri('JTH', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'mg-road-biriyani-co-blr',
    name: 'MG Road Biriyani Co.',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'Biriyani • Kebabs • Mughlai',
    address: 'MG Road, Bengaluru, Karnataka 560001',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/mg-road-biriyani-co-blr-cover/1600/900',
    logo: svgLogoDataUri('MGB', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'hsr-salad-lab-blr',
    name: 'HSR Salad Lab',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'Healthy • Salads • Bowls',
    address: 'Sector 2, HSR Layout, Bengaluru, Karnataka 560102',
    openingTime: '10:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/hsr-salad-lab-blr-cover/1600/900',
    logo: svgLogoDataUri('HSL', '#166534', '#f0fdf4'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'malleshwaram-filter-coffee-blr',
    name: 'Malleshwaram Filter Coffee & Snacks',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'South Indian • Snacks • Cafe',
    address: '8th Cross, Malleshwaram, Bengaluru, Karnataka 560003',
    openingTime: '7:30 AM',
    closingTime: '9:30 PM',
    image: 'https://picsum.photos/seed/malleshwaram-filter-coffee-blr-cover/1600/900',
    logo: svgLogoDataUri('MFC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'btm-rolls-and-kebabs-blr',
    name: 'BTM Rolls & Kebabs',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'Rolls • Kebabs • Fast Food',
    address: 'Stage 2, BTM Layout, Bengaluru, Karnataka 560076',
    openingTime: '12:00 PM',
    closingTime: '12:30 AM',
    image: 'https://picsum.photos/seed/btm-rolls-and-kebabs-blr-cover/1600/900',
    logo: svgLogoDataUri('BTM', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'bellandur-pasta-bar-blr',
    name: 'Bellandur Pasta Bar',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'Italian • Pizza • Pasta',
    address: 'Outer Ring Road, Bellandur, Bengaluru, Karnataka 560103',
    openingTime: '12:00 PM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/bellandur-pasta-bar-blr-cover/1600/900',
    logo: svgLogoDataUri('BPB', '#0f172a', '#e2e8f0'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'rajajinagar-tiffin-room-blr',
    name: 'Rajajinagar Tiffin Room',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'South Indian • Tiffin • Vegetarian',
    address: 'Dr. Rajkumar Road, Rajajinagar, Bengaluru, Karnataka 560010',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/rajajinagar-tiffin-room-blr-cover/1600/900',
    logo: svgLogoDataUri('RTR', '#1f2937', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'marathahalli-bowl-company-blr',
    name: 'Marathahalli Bowl Company',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'Healthy • Bowls • Continental',
    address: 'ORR Service Road, Marathahalli, Bengaluru, Karnataka 560037',
    openingTime: '11:00 AM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/marathahalli-bowl-company-blr-cover/1600/900',
    logo: svgLogoDataUri('MBC', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'basavanagudi-mylari-style-blr',
    name: 'Basavanagudi Mylari Style Dosa',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'South Indian • Dosa • Breakfast',
    address: 'Gandhi Bazaar, Basavanagudi, Bengaluru, Karnataka 560004',
    openingTime: '7:30 AM',
    closingTime: '2:30 PM',
    image: 'https://picsum.photos/seed/basavanagudi-mylari-style-blr-cover/1600/900',
    logo: svgLogoDataUri('BMS', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'electronic-city-spice-route-blr',
    name: 'Electronic City Spice Route',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'North Indian • Chinese • Fast Food',
    address: 'Phase 1, Electronic City, Bengaluru, Karnataka 560100',
    openingTime: '12:00 PM',
    closingTime: '12:00 AM',
    image: 'https://picsum.photos/seed/electronic-city-spice-route-blr-cover/1600/900',
    logo: svgLogoDataUri('ECS', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'sahakarnagar-bakery-and-brews-blr',
    name: 'Sahakarnagar Bakery & Brews',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Sahakarnagar, Bengaluru, Karnataka 560092',
    openingTime: '8:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/sahakarnagar-bakery-and-brews-blr-cover/1600/900',
    logo: svgLogoDataUri('SBB', '#a16207', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'banjara-spice-atelier-hyd',
    name: 'Banjara Spice Atelier',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'Hyderabadi • North Indian • Kebabs',
    address: 'Road No. 12, Banjara Hills, Hyderabad, Telangana 500034',
    openingTime: '12:00 PM',
    closingTime: '12:30 AM',
    image: 'https://picsum.photos/seed/banjara-spice-atelier-hyd-cover/1600/900',
    logo: svgLogoDataUri('BSA', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'jubilee-biryani-works-hyd',
    name: 'Jubilee Biryani Works',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'Biriyani • Mughlai • Kebabs',
    address: 'Jubilee Hills Rd No. 36, Hyderabad, Telangana 500033',
    openingTime: '11:30 AM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/jubilee-biryani-works-hyd-cover/1600/900',
    logo: svgLogoDataUri('JBW', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'old-city-kebab-bazaar-hyd',
    name: 'Old City Kebab Bazaar',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'Kebabs • Rolls • Street Food',
    address: 'Near Charminar, Old City, Hyderabad, Telangana 500002',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/old-city-kebab-bazaar-hyd-cover/1600/900',
    logo: svgLogoDataUri('OKB', '#1d4ed8', '#eff6ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'gachibowli-bowl-studio-hyd',
    name: 'Gachibowli Bowl Studio',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Financial District Rd, Gachibowli, Hyderabad, Telangana 500032',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/gachibowli-bowl-studio-hyd-cover/1600/900',
    logo: svgLogoDataUri('GBS', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'hitech-city-wok-house-hyd',
    name: 'Hitech City Wok House',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'HITEC City, Madhapur, Hyderabad, Telangana 500081',
    openingTime: '12:00 PM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/hitech-city-wok-house-hyd-cover/1600/900',
    logo: svgLogoDataUri('HWH', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'secunderabad-tiffin-corner-hyd',
    name: 'Secunderabad Tiffin Corner',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'South Indian • Breakfast • Tiffin',
    address: 'SP Road, Secunderabad, Hyderabad, Telangana 500003',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/secunderabad-tiffin-corner-hyd-cover/1600/900',
    logo: svgLogoDataUri('STC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kondapur-bakery-and-brews-hyd',
    name: 'Kondapur Bakery & Brews',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Kondapur Main Rd, Hyderabad, Telangana 500084',
    openingTime: '8:00 AM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/kondapur-bakery-and-brews-hyd-cover/1600/900',
    logo: svgLogoDataUri('KBB', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'begumpet-grill-and-platter-hyd',
    name: 'Begumpet Grill & Platter',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'Grills • BBQ • Continental',
    address: 'Greenlands Rd, Begumpet, Hyderabad, Telangana 500016',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/begumpet-grill-and-platter-hyd-cover/1600/900',
    logo: svgLogoDataUri('BGP', '#a16207', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'koregaon-park-cafe-collective-pun',
    name: 'Koregaon Park Cafe Collective',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Lane 6, Koregaon Park, Pune, Maharashtra 411001',
    openingTime: '8:30 AM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/koregaon-park-cafe-collective-pun-cover/1600/900',
    logo: svgLogoDataUri('KPCC', '#1d4ed8', '#eff6ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'baner-bowl-lab-pun',
    name: 'Baner Bowl Lab',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Baner Rd, Pune, Maharashtra 411045',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/baner-bowl-lab-pun-cover/1600/900',
    logo: svgLogoDataUri('BBL', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'hinjewadi-wok-yard-pun',
    name: 'Hinjewadi Wok Yard',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'Phase 1, Hinjewadi, Pune, Maharashtra 411057',
    openingTime: '12:00 PM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/hinjewadi-wok-yard-pun-cover/1600/900',
    logo: svgLogoDataUri('HWY', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'fc-road-misal-and-thali-pun',
    name: 'FC Road Misal & Thali',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'Maharashtrian • Thali • Vegetarian',
    address: 'FC Road, Shivajinagar, Pune, Maharashtra 411004',
    openingTime: '8:00 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/fc-road-misal-and-thali-pun-cover/1600/900',
    logo: svgLogoDataUri('FMR', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'viman-nagar-grill-room-pun',
    name: 'Viman Nagar Grill Room',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'Grills • BBQ • Continental',
    address: 'Viman Nagar, Pune, Maharashtra 411014',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/viman-nagar-grill-room-pun-cover/1600/900',
    logo: svgLogoDataUri('VNGR', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kothrud-tiffin-corner-pun',
    name: 'Kothrud Tiffin Corner',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'South Indian • Tiffin • Breakfast',
    address: 'Karve Rd, Kothrud, Pune, Maharashtra 411038',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/kothrud-tiffin-corner-pun-cover/1600/900',
    logo: svgLogoDataUri('KTTC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'camp-kebab-and-rolls-pun',
    name: 'Camp Kebab & Rolls',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'Kebabs • Rolls • Street Food',
    address: 'MG Road, Camp, Pune, Maharashtra 411001',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/camp-kebab-and-rolls-pun-cover/1600/900',
    logo: svgLogoDataUri('CKR', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kalyani-nagar-biryani-atelier-pun',
    name: 'Kalyani Nagar Biryani Atelier',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'Biriyani • Mughlai • Kebabs',
    address: 'Kalyani Nagar, Pune, Maharashtra 411006',
    openingTime: '11:30 AM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/kalyani-nagar-biryani-atelier-pun-cover/1600/900',
    logo: svgLogoDataUri('KNBA', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'bandra-bay-cafe-collective-mum',
    name: 'Bandra Bay Cafe Collective',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Hill Road, Bandra West, Mumbai, Maharashtra 400050',
    openingTime: '8:00 AM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/bandra-bay-cafe-collective-mum-cover/1600/900',
    logo: svgLogoDataUri('BBCC', '#1d4ed8', '#eff6ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'andheri-wok-street-mum',
    name: 'Andheri Wok Street',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'Veera Desai Rd, Andheri West, Mumbai, Maharashtra 400053',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/andheri-wok-street-mum-cover/1600/900',
    logo: svgLogoDataUri('AWS', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'lower-parel-grill-room-mum',
    name: 'Lower Parel Grill Room',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'Grills • BBQ • Continental',
    address: 'Senapati Bapat Marg, Lower Parel, Mumbai, Maharashtra 400013',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/lower-parel-grill-room-mum-cover/1600/900',
    logo: svgLogoDataUri('LPGR', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'dadar-misal-and-thali-mum',
    name: 'Dadar Misal & Thali',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'Maharashtrian • Thali • Vegetarian',
    address: 'Dadar West, Mumbai, Maharashtra 400028',
    openingTime: '8:00 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/dadar-misal-and-thali-mum-cover/1600/900',
    logo: svgLogoDataUri('DMT', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'colaba-kebab-and-rolls-mum',
    name: 'Colaba Kebab & Rolls',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'Kebabs • Rolls • Street Food',
    address: 'Colaba Causeway, Mumbai, Maharashtra 400005',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/colaba-kebab-and-rolls-mum-cover/1600/900',
    logo: svgLogoDataUri('CKR', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'powai-bowl-lab-mum',
    name: 'Powai Bowl Lab',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Hiranandani Gardens, Powai, Mumbai, Maharashtra 400076',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/powai-bowl-lab-mum-cover/1600/900',
    logo: svgLogoDataUri('PBL', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'matunga-tiffin-corner-mum',
    name: 'Matunga Tiffin Corner',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'South Indian • Tiffin • Breakfast',
    address: 'Matunga East, Mumbai, Maharashtra 400019',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/matunga-tiffin-corner-mum-cover/1600/900',
    logo: svgLogoDataUri('MTC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kurla-biryani-atelier-mum',
    name: 'Kurla Biryani Atelier',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'Biriyani • Mughlai • Kebabs',
    address: 'LBS Marg, Kurla West, Mumbai, Maharashtra 400070',
    openingTime: '11:30 AM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/kurla-biryani-atelier-mum-cover/1600/900',
    logo: svgLogoDataUri('KBA', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'cp-cafe-collective-del',
    name: 'CP Cafe Collective',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Connaught Place, New Delhi, Delhi 110001',
    openingTime: '8:00 AM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/cp-cafe-collective-del-cover/1600/900',
    logo: svgLogoDataUri('CPCC', '#1d4ed8', '#eff6ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'hauz-khas-wok-street-del',
    name: 'Hauz Khas Wok Street',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'Hauz Khas Village, New Delhi, Delhi 110016',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/hauz-khas-wok-street-del-cover/1600/900',
    logo: svgLogoDataUri('HKWS', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'khan-market-grill-room-del',
    name: 'Khan Market Grill Room',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'Grills • BBQ • Continental',
    address: 'Khan Market, New Delhi, Delhi 110003',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/khan-market-grill-room-del-cover/1600/900',
    logo: svgLogoDataUri('KMGR', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'chandni-chowk-kebab-and-rolls-del',
    name: 'Chandni Chowk Kebab & Rolls',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'Kebabs • Rolls • Street Food',
    address: 'Chandni Chowk, Old Delhi, Delhi 110006',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/chandni-chowk-kebab-and-rolls-del-cover/1600/900',
    logo: svgLogoDataUri('CCKR', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'karol-bagh-misal-and-thali-del',
    name: 'Karol Bagh Misal & Thali',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'North Indian • Thali • Vegetarian',
    address: 'Karol Bagh, New Delhi, Delhi 110005',
    openingTime: '8:00 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/karol-bagh-misal-and-thali-del-cover/1600/900',
    logo: svgLogoDataUri('KBMT', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'dwarka-bowl-lab-del',
    name: 'Dwarka Bowl Lab',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Sector 10, Dwarka, New Delhi, Delhi 110075',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/dwarka-bowl-lab-del-cover/1600/900',
    logo: svgLogoDataUri('DBL', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'saravana-tiffin-corner-del',
    name: 'Saravana Tiffin Corner',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'South Indian • Tiffin • Breakfast',
    address: 'RK Puram, New Delhi, Delhi 110022',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/saravana-tiffin-corner-del-cover/1600/900',
    logo: svgLogoDataUri('STC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'nizamuddin-biryani-atelier-del',
    name: 'Nizamuddin Biryani Atelier',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'Biriyani • Mughlai • Kebabs',
    address: 'Nizamuddin West, New Delhi, Delhi 110013',
    openingTime: '11:30 AM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/nizamuddin-biryani-atelier-del-cover/1600/900',
    logo: svgLogoDataUri('NBA', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },

  // Bengaluru (add 5 to reach 21)
  {
    _id: 'hebbal-bowl-studio-blr',
    name: 'Hebbal Bowl Studio',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Bellary Road, Hebbal, Bengaluru, Karnataka 560024',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/hebbal-bowl-studio-blr-cover/1600/900',
    logo: svgLogoDataUri('HBS', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'jp-nagar-noodle-yard-blr',
    name: 'JP Nagar Noodle Yard',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: '15th Cross, JP Nagar 2nd Phase, Bengaluru, Karnataka 560078',
    openingTime: '12:00 PM',
    closingTime: '11:15 PM',
    image: 'https://picsum.photos/seed/jp-nagar-noodle-yard-blr-cover/1600/900',
    logo: svgLogoDataUri('JPNY', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'frazer-town-kebab-room-blr',
    name: 'Frazer Town Kebab Room',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'Kebabs • Rolls • Mughlai',
    address: 'Mosque Road, Frazer Town, Bengaluru, Karnataka 560005',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/frazer-town-kebab-room-blr-cover/1600/900',
    logo: svgLogoDataUri('FTKR', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'banashankari-thali-craft-blr',
    name: 'Banashankari Thali Craft',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'North Indian • Thali • Vegetarian',
    address: 'BSK 3rd Stage, Banashankari, Bengaluru, Karnataka 560085',
    openingTime: '11:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/banashankari-thali-craft-blr-cover/1600/900',
    logo: svgLogoDataUri('BTC', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kalyan-nagar-cafe-pantry-blr',
    name: 'Kalyan Nagar Cafe Pantry',
    city: 'Bengaluru',
    state: 'Karnataka',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'HRBR Layout, Kalyan Nagar, Bengaluru, Karnataka 560043',
    openingTime: '8:00 AM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/kalyan-nagar-cafe-pantry-blr-cover/1600/900',
    logo: svgLogoDataUri('KNCP', '#1d4ed8', '#eff6ff'),
    isActive: true,
    taxPercentage: 5
  },

  // Hyderabad (add 13 to reach 21)
  {
    _id: 'madhapur-cafe-collective-hyd',
    name: 'Madhapur Cafe Collective',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Ayyappa Society Rd, Madhapur, Hyderabad, Telangana 500081',
    openingTime: '8:00 AM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/madhapur-cafe-collective-hyd-cover/1600/900',
    logo: svgLogoDataUri('MCC', '#1d4ed8', '#eff6ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kukatpally-bowl-lab-hyd',
    name: 'Kukatpally Bowl Lab',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'KPHB Phase 2, Kukatpally, Hyderabad, Telangana 500072',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/kukatpally-bowl-lab-hyd-cover/1600/900',
    logo: svgLogoDataUri('KBL', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'ameerpet-wok-street-hyd',
    name: 'Ameerpet Wok Street',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'SR Nagar Rd, Ameerpet, Hyderabad, Telangana 500038',
    openingTime: '12:00 PM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/ameerpet-wok-street-hyd-cover/1600/900',
    logo: svgLogoDataUri('AWS', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'tolichowki-kebab-room-hyd',
    name: 'Tolichowki Kebab Room',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'Kebabs • Rolls • Mughlai',
    address: 'Tolichowki, Hyderabad, Telangana 500008',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/tolichowki-kebab-room-hyd-cover/1600/900',
    logo: svgLogoDataUri('TKR', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'dilsukhnagar-thali-house-hyd',
    name: 'Dilsukhnagar Thali House',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'North Indian • Thali • Vegetarian',
    address: 'Dilsukhnagar, Hyderabad, Telangana 500060',
    openingTime: '11:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/dilsukhnagar-thali-house-hyd-cover/1600/900',
    logo: svgLogoDataUri('DTH', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'abids-biryani-atelier-hyd',
    name: 'Abids Biryani Atelier',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'Hyderabadi • Biriyani • Kebabs',
    address: 'Abids Rd, Hyderabad, Telangana 500001',
    openingTime: '11:30 AM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/abids-biryani-atelier-hyd-cover/1600/900',
    logo: svgLogoDataUri('ABA', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'sainikpuri-tiffin-corner-hyd',
    name: 'Sainikpuri Tiffin Corner',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'South Indian • Tiffin • Breakfast',
    address: 'Sainikpuri, Secunderabad, Telangana 500094',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/sainikpuri-tiffin-corner-hyd-cover/1600/900',
    logo: svgLogoDataUri('STC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'somajiguda-grill-room-hyd',
    name: 'Somajiguda Grill Room',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'Grills • BBQ • Continental',
    address: 'Raj Bhavan Rd, Somajiguda, Hyderabad, Telangana 500082',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/somajiguda-grill-room-hyd-cover/1600/900',
    logo: svgLogoDataUri('SGR', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'lb-nagar-bakery-and-brews-hyd',
    name: 'LB Nagar Bakery & Brews',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'LB Nagar, Hyderabad, Telangana 500074',
    openingTime: '8:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/lb-nagar-bakery-and-brews-hyd-cover/1600/900',
    logo: svgLogoDataUri('LBBB', '#a16207', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'attapur-pasta-bar-hyd',
    name: 'Attapur Pasta Bar',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'Italian • Pizza • Pasta',
    address: 'Attapur, Hyderabad, Telangana 500048',
    openingTime: '12:00 PM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/attapur-pasta-bar-hyd-cover/1600/900',
    logo: svgLogoDataUri('APB', '#0f172a', '#e2e8f0'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'uppal-dosa-club-hyd',
    name: 'Uppal Dosa Club',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'South Indian • Dosa • Breakfast',
    address: 'Uppal, Hyderabad, Telangana 500039',
    openingTime: '7:30 AM',
    closingTime: '2:30 PM',
    image: 'https://picsum.photos/seed/uppal-dosa-club-hyd-cover/1600/900',
    logo: svgLogoDataUri('UDC', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'charminar-sweets-and-chai-hyd',
    name: 'Charminar Sweets & Chai',
    city: 'Hyderabad',
    state: 'Telangana',
    cuisine: 'Desserts • Bakery • Beverages',
    address: 'Charminar Rd, Hyderabad, Telangana 500002',
    openingTime: '9:00 AM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/charminar-sweets-and-chai-hyd-cover/1600/900',
    logo: svgLogoDataUri('CSC', '#1f2937', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },

  // Pune (add 13 to reach 21)
  {
    _id: 'aundh-cafe-collective-pun',
    name: 'Aundh Cafe Collective',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'ITI Road, Aundh, Pune, Maharashtra 411007',
    openingTime: '8:00 AM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/aundh-cafe-collective-pun-cover/1600/900',
    logo: svgLogoDataUri('ACC', '#1d4ed8', '#eff6ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'wakad-bowl-lab-pun',
    name: 'Wakad Bowl Lab',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Wakad, Pune, Maharashtra 411057',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/wakad-bowl-lab-pun-cover/1600/900',
    logo: svgLogoDataUri('WBL', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kharadi-wok-street-pun',
    name: 'Kharadi Wok Street',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'EON IT Park Rd, Kharadi, Pune, Maharashtra 411014',
    openingTime: '12:00 PM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/kharadi-wok-street-pun-cover/1600/900',
    logo: svgLogoDataUri('KWS', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'shivaji-nagar-grill-room-pun',
    name: 'Shivaji Nagar Grill Room',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'Grills • BBQ • Continental',
    address: 'Senapati Bapat Rd, Shivaji Nagar, Pune, Maharashtra 411005',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/shivaji-nagar-grill-room-pun-cover/1600/900',
    logo: svgLogoDataUri('SNGR', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'hadapsar-kebab-room-pun',
    name: 'Hadapsar Kebab Room',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'Kebabs • Rolls • Mughlai',
    address: 'Hadapsar, Pune, Maharashtra 411028',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/hadapsar-kebab-room-pun-cover/1600/900',
    logo: svgLogoDataUri('HKR', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'pashan-thali-house-pun',
    name: 'Pashan Thali House',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'North Indian • Thali • Vegetarian',
    address: 'Pashan, Pune, Maharashtra 411021',
    openingTime: '11:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/pashan-thali-house-pun-cover/1600/900',
    logo: svgLogoDataUri('PTH', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'nigdi-tiffin-corner-pun',
    name: 'Nigdi Tiffin Corner',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'South Indian • Tiffin • Breakfast',
    address: 'Nigdi, Pimpri-Chinchwad, Pune, Maharashtra 411044',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/nigdi-tiffin-corner-pun-cover/1600/900',
    logo: svgLogoDataUri('NTC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'swargate-misal-and-thali-pun',
    name: 'Swargate Misal & Thali',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'Misal • Thali • Maharashtrian',
    address: 'Swargate, Pune, Maharashtra 411037',
    openingTime: '8:00 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/swargate-misal-and-thali-pun-cover/1600/900',
    logo: svgLogoDataUri('SMT', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kondhwa-biryani-atelier-pun',
    name: 'Kondhwa Biryani Atelier',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'Biriyani • Mughlai • Kebabs',
    address: 'Kondhwa, Pune, Maharashtra 411048',
    openingTime: '11:30 AM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/kondhwa-biryani-atelier-pun-cover/1600/900',
    logo: svgLogoDataUri('KBA', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'yerwada-pasta-bar-pun',
    name: 'Yerwada Pasta Bar',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'Italian • Pizza • Pasta',
    address: 'Yerwada, Pune, Maharashtra 411006',
    openingTime: '12:00 PM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/yerwada-pasta-bar-pun-cover/1600/900',
    logo: svgLogoDataUri('YPB', '#0f172a', '#e2e8f0'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'balewadi-dosa-club-pun',
    name: 'Balewadi Dosa Club',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'South Indian • Dosa • Breakfast',
    address: 'Balewadi High Street, Pune, Maharashtra 411045',
    openingTime: '7:30 AM',
    closingTime: '2:30 PM',
    image: 'https://picsum.photos/seed/balewadi-dosa-club-pun-cover/1600/900',
    logo: svgLogoDataUri('BDC', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kothrud-sweets-and-chai-pun',
    name: 'Kothrud Sweets & Chai',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'Desserts • Bakery • Beverages',
    address: 'Karve Rd, Kothrud, Pune, Maharashtra 411038',
    openingTime: '9:00 AM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/kothrud-sweets-and-chai-pun-cover/1600/900',
    logo: svgLogoDataUri('KSC', '#1f2937', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'magarpatta-bakery-and-brews-pun',
    name: 'Magarpatta Bakery & Brews',
    city: 'Pune',
    state: 'Maharashtra',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Magarpatta City, Hadapsar, Pune, Maharashtra 411028',
    openingTime: '8:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/magarpatta-bakery-and-brews-pun-cover/1600/900',
    logo: svgLogoDataUri('MBB', '#a16207', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },

  // Mumbai (add 13 to reach 21)
  {
    _id: 'goregaon-cafe-collective-mum',
    name: 'Goregaon Cafe Collective',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Goregaon West, Mumbai, Maharashtra 400104',
    openingTime: '8:00 AM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/goregaon-cafe-collective-mum-cover/1600/900',
    logo: svgLogoDataUri('GCC', '#1d4ed8', '#eff6ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'mulund-bowl-lab-mum',
    name: 'Mulund Bowl Lab',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Mulund West, Mumbai, Maharashtra 400080',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/mulund-bowl-lab-mum-cover/1600/900',
    logo: svgLogoDataUri('MBL', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'borivali-wok-street-mum',
    name: 'Borivali Wok Street',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'Borivali West, Mumbai, Maharashtra 400092',
    openingTime: '12:00 PM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/borivali-wok-street-mum-cover/1600/900',
    logo: svgLogoDataUri('BWS', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'chembur-grill-room-mum',
    name: 'Chembur Grill Room',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'Grills • BBQ • Continental',
    address: 'Chembur East, Mumbai, Maharashtra 400071',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/chembur-grill-room-mum-cover/1600/900',
    logo: svgLogoDataUri('CGR', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'sion-kebab-room-mum',
    name: 'Sion Kebab Room',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'Kebabs • Rolls • Mughlai',
    address: 'Sion, Mumbai, Maharashtra 400022',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/sion-kebab-room-mum-cover/1600/900',
    logo: svgLogoDataUri('SKR', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'vikhroli-thali-house-mum',
    name: 'Vikhroli Thali House',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'North Indian • Thali • Vegetarian',
    address: 'Vikhroli West, Mumbai, Maharashtra 400079',
    openingTime: '11:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/vikhroli-thali-house-mum-cover/1600/900',
    logo: svgLogoDataUri('VTH', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'ghatkopar-tiffin-corner-mum',
    name: 'Ghatkopar Tiffin Corner',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'South Indian • Tiffin • Breakfast',
    address: 'Ghatkopar East, Mumbai, Maharashtra 400077',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/ghatkopar-tiffin-corner-mum-cover/1600/900',
    logo: svgLogoDataUri('GTC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'thane-misal-and-thali-mum',
    name: 'Thane Misal & Thali',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'Misal • Thali • Maharashtrian',
    address: 'Thane West, Maharashtra 400601',
    openingTime: '8:00 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/thane-misal-and-thali-mum-cover/1600/900',
    logo: svgLogoDataUri('TMT', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'bhandup-biryani-atelier-mum',
    name: 'Bhandup Biryani Atelier',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'Biriyani • Mughlai • Kebabs',
    address: 'Bhandup West, Mumbai, Maharashtra 400078',
    openingTime: '11:30 AM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/bhandup-biryani-atelier-mum-cover/1600/900',
    logo: svgLogoDataUri('BBA', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'versova-pasta-bar-mum',
    name: 'Versova Pasta Bar',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'Italian • Pizza • Pasta',
    address: 'Versova, Andheri West, Mumbai, Maharashtra 400061',
    openingTime: '12:00 PM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/versova-pasta-bar-mum-cover/1600/900',
    logo: svgLogoDataUri('VPB', '#0f172a', '#e2e8f0'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'dahisar-dosa-club-mum',
    name: 'Dahisar Dosa Club',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'South Indian • Dosa • Breakfast',
    address: 'Dahisar East, Mumbai, Maharashtra 400068',
    openingTime: '7:30 AM',
    closingTime: '2:30 PM',
    image: 'https://picsum.photos/seed/dahisar-dosa-club-mum-cover/1600/900',
    logo: svgLogoDataUri('DDC', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'byculla-sweets-and-chai-mum',
    name: 'Byculla Sweets & Chai',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'Desserts • Bakery • Beverages',
    address: 'Byculla, Mumbai, Maharashtra 400011',
    openingTime: '9:00 AM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/byculla-sweets-and-chai-mum-cover/1600/900',
    logo: svgLogoDataUri('BSC', '#1f2937', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'seawoods-bakery-and-brews-mum',
    name: 'Seawoods Bakery & Brews',
    city: 'Mumbai',
    state: 'Maharashtra',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Seawoods, Navi Mumbai, Maharashtra 400706',
    openingTime: '8:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/seawoods-bakery-and-brews-mum-cover/1600/900',
    logo: svgLogoDataUri('SBB', '#a16207', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },

  // New Delhi (add 13 to reach 21)
  {
    _id: 'lajpat-nagar-cafe-collective-del',
    name: 'Lajpat Nagar Cafe Collective',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Central Market, Lajpat Nagar, New Delhi, Delhi 110024',
    openingTime: '8:00 AM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/lajpat-nagar-cafe-collective-del-cover/1600/900',
    logo: svgLogoDataUri('LNCC', '#1d4ed8', '#eff6ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'saket-bowl-lab-del',
    name: 'Saket Bowl Lab',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Select Citywalk Rd, Saket, New Delhi, Delhi 110017',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/saket-bowl-lab-del-cover/1600/900',
    logo: svgLogoDataUri('SBL', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'greater-kailash-wok-street-del',
    name: 'Greater Kailash Wok Street',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'M Block Market, GK 1, New Delhi, Delhi 110048',
    openingTime: '12:00 PM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/greater-kailash-wok-street-del-cover/1600/900',
    logo: svgLogoDataUri('GKWS', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'rajouri-garden-grill-room-del',
    name: 'Rajouri Garden Grill Room',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'Grills • BBQ • Continental',
    address: 'Rajouri Garden, New Delhi, Delhi 110027',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/rajouri-garden-grill-room-del-cover/1600/900',
    logo: svgLogoDataUri('RGGR', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'jamia-kebab-room-del',
    name: 'Jamia Kebab Room',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'Kebabs • Rolls • Mughlai',
    address: 'Jamia Nagar, Okhla, New Delhi, Delhi 110025',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/jamia-kebab-room-del-cover/1600/900',
    logo: svgLogoDataUri('JKR', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'pitampura-thali-house-del',
    name: 'Pitampura Thali House',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'North Indian • Thali • Vegetarian',
    address: 'Pitampura, New Delhi, Delhi 110034',
    openingTime: '11:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/pitampura-thali-house-del-cover/1600/900',
    logo: svgLogoDataUri('PTH', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'janakpuri-tiffin-corner-del',
    name: 'Janakpuri Tiffin Corner',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'South Indian • Tiffin • Breakfast',
    address: 'Janakpuri, New Delhi, Delhi 110058',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/janakpuri-tiffin-corner-del-cover/1600/900',
    logo: svgLogoDataUri('JTC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'laxmi-nagar-misal-and-thali-del',
    name: 'Laxmi Nagar Misal & Thali',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'Thali • Vegetarian • Comfort Food',
    address: 'Laxmi Nagar, New Delhi, Delhi 110092',
    openingTime: '8:00 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/laxmi-nagar-misal-and-thali-del-cover/1600/900',
    logo: svgLogoDataUri('LNMT', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'narela-biryani-atelier-del',
    name: 'Narela Biryani Atelier',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'Biriyani • Mughlai • Kebabs',
    address: 'Narela, New Delhi, Delhi 110040',
    openingTime: '11:30 AM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/narela-biryani-atelier-del-cover/1600/900',
    logo: svgLogoDataUri('NBA', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'dwarka-pasta-bar-del',
    name: 'Dwarka Pasta Bar',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'Italian • Pizza • Pasta',
    address: 'Sector 12, Dwarka, New Delhi, Delhi 110075',
    openingTime: '12:00 PM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/dwarka-pasta-bar-del-cover/1600/900',
    logo: svgLogoDataUri('DPB', '#0f172a', '#e2e8f0'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'rohini-dosa-club-del',
    name: 'Rohini Dosa Club',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'South Indian • Dosa • Breakfast',
    address: 'Rohini Sector 9, New Delhi, Delhi 110085',
    openingTime: '7:30 AM',
    closingTime: '2:30 PM',
    image: 'https://picsum.photos/seed/rohini-dosa-club-del-cover/1600/900',
    logo: svgLogoDataUri('RDC', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'cp-sweets-and-chai-del',
    name: 'CP Sweets & Chai',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'Desserts • Bakery • Beverages',
    address: 'Janpath Rd, Connaught Place, New Delhi, Delhi 110001',
    openingTime: '9:00 AM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/cp-sweets-and-chai-del-cover/1600/900',
    logo: svgLogoDataUri('CSCH', '#1f2937', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'mayur-vihar-bakery-and-brews-del',
    name: 'Mayur Vihar Bakery & Brews',
    city: 'New Delhi',
    state: 'Delhi',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Mayur Vihar Phase 1, New Delhi, Delhi 110091',
    openingTime: '8:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/mayur-vihar-bakery-and-brews-del-cover/1600/900',
    logo: svgLogoDataUri('MVBB', '#a16207', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },

  // Bhopal (32)
  {
    _id: 'mp-nagar-cafe-collective-bhp',
    name: 'MP Nagar Cafe Collective',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Zone 1, MP Nagar, Bhopal, Madhya Pradesh 462011',
    openingTime: '8:00 AM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/mp-nagar-cafe-collective-bhp-cover/1600/900',
    logo: svgLogoDataUri('MPCC', '#1d4ed8', '#eff6ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'arera-hills-bowl-lab-bhp',
    name: 'Arera Hills Bowl Lab',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Arera Hills, Bhopal, Madhya Pradesh 462011',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/arera-hills-bowl-lab-bhp-cover/1600/900',
    logo: svgLogoDataUri('AHBL', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'tt-nagar-wok-street-bhp',
    name: 'TT Nagar Wok Street',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'TT Nagar, Bhopal, Madhya Pradesh 462003',
    openingTime: '12:00 PM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/tt-nagar-wok-street-bhp-cover/1600/900',
    logo: svgLogoDataUri('TNWS', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'new-market-grill-room-bhp',
    name: 'New Market Grill Room',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Grills • BBQ • Continental',
    address: 'New Market, TT Nagar, Bhopal, Madhya Pradesh 462003',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/new-market-grill-room-bhp-cover/1600/900',
    logo: svgLogoDataUri('NMGR', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'old-bhopal-kebab-room-bhp',
    name: 'Old Bhopal Kebab Room',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Kebabs • Rolls • Mughlai',
    address: 'Ibrahimpura, Old Bhopal, Madhya Pradesh 462001',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/old-bhopal-kebab-room-bhp-cover/1600/900',
    logo: svgLogoDataUri('OBKR', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'arera-colony-thali-house-bhp',
    name: 'Arera Colony Thali House',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'North Indian • Thali • Vegetarian',
    address: 'E-7, Arera Colony, Bhopal, Madhya Pradesh 462016',
    openingTime: '11:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/arera-colony-thali-house-bhp-cover/1600/900',
    logo: svgLogoDataUri('ACTH', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'bittan-market-tiffin-corner-bhp',
    name: 'Bittan Market Tiffin Corner',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'South Indian • Tiffin • Breakfast',
    address: 'Bittan Market, Arera Colony, Bhopal, Madhya Pradesh 462016',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/bittan-market-tiffin-corner-bhp-cover/1600/900',
    logo: svgLogoDataUri('BMTC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'lalghati-biryani-atelier-bhp',
    name: 'Lalghati Biryani Atelier',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Biriyani • Mughlai • Kebabs',
    address: 'Lalghati, Bhopal, Madhya Pradesh 462030',
    openingTime: '11:30 AM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/lalghati-biryani-atelier-bhp-cover/1600/900',
    logo: svgLogoDataUri('LBA', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kolar-road-pasta-bar-bhp',
    name: 'Kolar Road Pasta Bar',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Italian • Pizza • Pasta',
    address: 'Kolar Road, Bhopal, Madhya Pradesh 462042',
    openingTime: '12:00 PM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/kolar-road-pasta-bar-bhp-cover/1600/900',
    logo: svgLogoDataUri('KRPB', '#0f172a', '#e2e8f0'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'shahpura-dosa-club-bhp',
    name: 'Shahpura Dosa Club',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'South Indian • Dosa • Breakfast',
    address: 'Shahpura, Bhopal, Madhya Pradesh 462016',
    openingTime: '7:30 AM',
    closingTime: '2:30 PM',
    image: 'https://picsum.photos/seed/shahpura-dosa-club-bhp-cover/1600/900',
    logo: svgLogoDataUri('SDC', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'bharat-talkies-sweets-and-chai-bhp',
    name: 'Bharat Talkies Sweets & Chai',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Desserts • Bakery • Beverages',
    address: 'Bharat Talkies Rd, Bhopal, Madhya Pradesh 462001',
    openingTime: '9:00 AM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/bharat-talkies-sweets-and-chai-bhp-cover/1600/900',
    logo: svgLogoDataUri('BTSC', '#1f2937', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'habsigunj-bakery-and-brews-bhp',
    name: 'Habsigunj Bakery & Brews',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Habsigunj, Bhopal, Madhya Pradesh 462024',
    openingTime: '8:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/habsigunj-bakery-and-brews-bhp-cover/1600/900',
    logo: svgLogoDataUri('HBBB', '#a16207', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'baghsewania-bowl-studio-bhp',
    name: 'Baghsewania Bowl Studio',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Baghsewania, Bhopal, Madhya Pradesh 462043',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/baghsewania-bowl-studio-bhp-cover/1600/900',
    logo: svgLogoDataUri('BBS', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'ayodhya-bypass-wok-yard-bhp',
    name: 'Ayodhya Bypass Wok Yard',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'Ayodhya Bypass Rd, Bhopal, Madhya Pradesh 462041',
    openingTime: '12:00 PM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/ayodhya-bypass-wok-yard-bhp-cover/1600/900',
    logo: svgLogoDataUri('ABWY', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kohefiza-grill-room-bhp',
    name: 'Kohefiza Grill Room',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Grills • BBQ • Continental',
    address: 'Kohefiza, Bhopal, Madhya Pradesh 462001',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/kohefiza-grill-room-bhp-cover/1600/900',
    logo: svgLogoDataUri('KGR', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'chhola-road-kebab-and-rolls-bhp',
    name: 'Chhola Road Kebab & Rolls',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Kebabs • Rolls • Street Food',
    address: 'Chhola Rd, Bhopal, Madhya Pradesh 462001',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/chhola-road-kebab-and-rolls-bhp-cover/1600/900',
    logo: svgLogoDataUri('CRKR', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'gulmohar-thali-craft-bhp',
    name: 'Gulmohar Thali Craft',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'North Indian • Thali • Vegetarian',
    address: 'Gulmohar Colony, Bhopal, Madhya Pradesh 462039',
    openingTime: '11:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/gulmohar-thali-craft-bhp-cover/1600/900',
    logo: svgLogoDataUri('GTC', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'indrapuri-tiffin-corner-bhp',
    name: 'Indrapuri Tiffin Corner',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'South Indian • Tiffin • Breakfast',
    address: 'Indrapuri, Bhopal, Madhya Pradesh 462021',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/indrapuri-tiffin-corner-bhp-cover/1600/900',
    logo: svgLogoDataUri('ITC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'ashoka-garden-biryani-atelier-bhp',
    name: 'Ashoka Garden Biryani Atelier',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Biriyani • Mughlai • Kebabs',
    address: 'Ashoka Garden, Bhopal, Madhya Pradesh 462023',
    openingTime: '11:30 AM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/ashoka-garden-biryani-atelier-bhp-cover/1600/900',
    logo: svgLogoDataUri('AGBA', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'bhel-pasta-bar-bhp',
    name: 'BHEL Pasta Bar',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Italian • Pizza • Pasta',
    address: 'BHEL, Bhopal, Madhya Pradesh 462022',
    openingTime: '12:00 PM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/bhel-pasta-bar-bhp-cover/1600/900',
    logo: svgLogoDataUri('BHPB', '#0f172a', '#e2e8f0'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'airport-road-dosa-club-bhp',
    name: 'Airport Road Dosa Club',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'South Indian • Dosa • Breakfast',
    address: 'Airport Rd, Bhopal, Madhya Pradesh 462036',
    openingTime: '7:30 AM',
    closingTime: '2:30 PM',
    image: 'https://picsum.photos/seed/airport-road-dosa-club-bhp-cover/1600/900',
    logo: svgLogoDataUri('ARDC', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'saket-nagar-sweets-and-chai-bhp',
    name: 'Saket Nagar Sweets & Chai',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Desserts • Bakery • Beverages',
    address: 'Saket Nagar, Bhopal, Madhya Pradesh 462024',
    openingTime: '9:00 AM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/saket-nagar-sweets-and-chai-bhp-cover/1600/900',
    logo: svgLogoDataUri('SNSC', '#1f2937', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'chuna-bhatti-bakery-and-brews-bhp',
    name: 'Chuna Bhatti Bakery & Brews',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Chuna Bhatti, Bhopal, Madhya Pradesh 462016',
    openingTime: '8:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/chuna-bhatti-bakery-and-brews-bhp-cover/1600/900',
    logo: svgLogoDataUri('CBBB', '#a16207', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'katara-hills-bowl-lab-bhp',
    name: 'Katara Hills Bowl Lab',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Katara Hills, Bhopal, Madhya Pradesh 462043',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/katara-hills-bowl-lab-bhp-cover/1600/900',
    logo: svgLogoDataUri('KHBL', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'misrod-wok-street-bhp',
    name: 'Misrod Wok Street',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'Misrod, Bhopal, Madhya Pradesh 462026',
    openingTime: '12:00 PM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/misrod-wok-street-bhp-cover/1600/900',
    logo: svgLogoDataUri('MWS', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'habibganj-grill-room-bhp',
    name: 'Habibganj Grill Room',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Grills • BBQ • Continental',
    address: 'Habibganj, Bhopal, Madhya Pradesh 462024',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/habibganj-grill-room-bhp-cover/1600/900',
    logo: svgLogoDataUri('HGR', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'peer-gate-kebab-room-bhp',
    name: 'Peer Gate Kebab Room',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Kebabs • Rolls • Mughlai',
    address: 'Peer Gate Area, Bhopal, Madhya Pradesh 462001',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/peer-gate-kebab-room-bhp-cover/1600/900',
    logo: svgLogoDataUri('PGKR', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'chowk-bazar-thali-house-bhp',
    name: 'Chowk Bazar Thali House',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'North Indian • Thali • Vegetarian',
    address: 'Chowk Bazar, Bhopal, Madhya Pradesh 462001',
    openingTime: '11:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/chowk-bazar-thali-house-bhp-cover/1600/900',
    logo: svgLogoDataUri('CBTH', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'piplani-tiffin-corner-bhp',
    name: 'Piplani Tiffin Corner',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'South Indian • Tiffin • Breakfast',
    address: 'Piplani, Bhopal, Madhya Pradesh 462022',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/piplani-tiffin-corner-bhp-cover/1600/900',
    logo: svgLogoDataUri('PTC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'mandideep-biryani-atelier-bhp',
    name: 'Mandideep Biryani Atelier',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Biriyani • Mughlai • Kebabs',
    address: 'Mandideep, Madhya Pradesh 462046',
    openingTime: '11:30 AM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/mandideep-biryani-atelier-bhp-cover/1600/900',
    logo: svgLogoDataUri('MBA', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'shalimar-pasta-bar-bhp',
    name: 'Shalimar Pasta Bar',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Italian • Pizza • Pasta',
    address: 'Shalimar Square, Bhopal, Madhya Pradesh 462039',
    openingTime: '12:00 PM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/shalimar-pasta-bar-bhp-cover/1600/900',
    logo: svgLogoDataUri('SPB', '#0f172a', '#e2e8f0'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'roshanpura-dosa-club-bhp',
    name: 'Roshanpura Dosa Club',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'South Indian • Dosa • Breakfast',
    address: 'Roshanpura, Bhopal, Madhya Pradesh 462003',
    openingTime: '7:30 AM',
    closingTime: '2:30 PM',
    image: 'https://picsum.photos/seed/roshanpura-dosa-club-bhp-cover/1600/900',
    logo: svgLogoDataUri('RDC', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'lalghati-sweets-and-chai-bhp',
    name: 'Lalghati Sweets & Chai',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Desserts • Bakery • Beverages',
    address: 'Lalghati, Bhopal, Madhya Pradesh 462030',
    openingTime: '9:00 AM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/lalghati-sweets-and-chai-bhp-cover/1600/900',
    logo: svgLogoDataUri('LSC', '#1f2937', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'arera-city-bakery-and-brews-bhp',
    name: 'Arera City Bakery & Brews',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Arera City, Bhopal, Madhya Pradesh 462016',
    openingTime: '8:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/arera-city-bakery-and-brews-bhp-cover/1600/900',
    logo: svgLogoDataUri('ACBB', '#a16207', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'bairagarh-market-cafe-collective-bhp',
    name: 'Bairagarh Market Cafe Collective',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Bairagarh, Bhopal, Madhya Pradesh 462030',
    openingTime: '8:00 AM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/bairagarh-market-cafe-collective-bhp-cover/1600/900',
    logo: svgLogoDataUri('BMCC', '#1d4ed8', '#eff6ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'jhangirabad-bowl-lab-bhp',
    name: 'Jhangirabad Bowl Lab',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Jahangirabad, Bhopal, Madhya Pradesh 462008',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/jhangirabad-bowl-lab-bhp-cover/1600/900',
    logo: svgLogoDataUri('JBBL', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },

  // Varanasi (15)
  {
    _id: 'lanka-cafe-collective-vns',
    name: 'Lanka Cafe Collective',
    city: 'Varanasi',
    state: 'Uttar Pradesh',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Lanka, Varanasi, Uttar Pradesh 221005',
    openingTime: '8:00 AM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/lanka-cafe-collective-vns-cover/1600/900',
    logo: svgLogoDataUri('LCC', '#1d4ed8', '#eff6ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'sigra-bowl-lab-vns',
    name: 'Sigra Bowl Lab',
    city: 'Varanasi',
    state: 'Uttar Pradesh',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Sigra, Varanasi, Uttar Pradesh 221010',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/sigra-bowl-lab-vns-cover/1600/900',
    logo: svgLogoDataUri('SBL', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'godowlia-wok-street-vns',
    name: 'Godowlia Wok Street',
    city: 'Varanasi',
    state: 'Uttar Pradesh',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'Godowlia, Varanasi, Uttar Pradesh 221001',
    openingTime: '12:00 PM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/godowlia-wok-street-vns-cover/1600/900',
    logo: svgLogoDataUri('GWS', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'assighat-grill-room-vns',
    name: 'Assi Ghat Grill Room',
    city: 'Varanasi',
    state: 'Uttar Pradesh',
    cuisine: 'Grills • BBQ • Continental',
    address: 'Assi Ghat, Varanasi, Uttar Pradesh 221005',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/assighat-grill-room-vns-cover/1600/900',
    logo: svgLogoDataUri('AGGR', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'chowk-kebab-room-vns',
    name: 'Chowk Kebab Room',
    city: 'Varanasi',
    state: 'Uttar Pradesh',
    cuisine: 'Kebabs • Rolls • Mughlai',
    address: 'Chowk, Varanasi, Uttar Pradesh 221001',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/chowk-kebab-room-vns-cover/1600/900',
    logo: svgLogoDataUri('CKR', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'bhelupur-thali-house-vns',
    name: 'Bhelupur Thali House',
    city: 'Varanasi',
    state: 'Uttar Pradesh',
    cuisine: 'North Indian • Thali • Vegetarian',
    address: 'Bhelupur, Varanasi, Uttar Pradesh 221010',
    openingTime: '11:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/bhelupur-thali-house-vns-cover/1600/900',
    logo: svgLogoDataUri('BTH', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'ravindrapuri-tiffin-corner-vns',
    name: 'Ravindrapuri Tiffin Corner',
    city: 'Varanasi',
    state: 'Uttar Pradesh',
    cuisine: 'South Indian • Tiffin • Breakfast',
    address: 'Ravindrapuri, Varanasi, Uttar Pradesh 221005',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/ravindrapuri-tiffin-corner-vns-cover/1600/900',
    logo: svgLogoDataUri('RTC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'cantt-biryani-atelier-vns',
    name: 'Cantt Biryani Atelier',
    city: 'Varanasi',
    state: 'Uttar Pradesh',
    cuisine: 'Biriyani • Mughlai • Kebabs',
    address: 'Varanasi Cantt, Uttar Pradesh 221002',
    openingTime: '11:30 AM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/cantt-biryani-atelier-vns-cover/1600/900',
    logo: svgLogoDataUri('CBA', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'shivpur-pasta-bar-vns',
    name: 'Shivpur Pasta Bar',
    city: 'Varanasi',
    state: 'Uttar Pradesh',
    cuisine: 'Italian • Pizza • Pasta',
    address: 'Shivpur, Varanasi, Uttar Pradesh 221003',
    openingTime: '12:00 PM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/shivpur-pasta-bar-vns-cover/1600/900',
    logo: svgLogoDataUri('SPB', '#0f172a', '#e2e8f0'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kabir-chaura-dosa-club-vns',
    name: 'Kabir Chaura Dosa Club',
    city: 'Varanasi',
    state: 'Uttar Pradesh',
    cuisine: 'South Indian • Dosa • Breakfast',
    address: 'Kabir Chaura, Varanasi, Uttar Pradesh 221001',
    openingTime: '7:30 AM',
    closingTime: '2:30 PM',
    image: 'https://picsum.photos/seed/kabir-chaura-dosa-club-vns-cover/1600/900',
    logo: svgLogoDataUri('KCDC', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'dashashwamedh-sweets-and-chai-vns',
    name: 'Dashashwamedh Sweets & Chai',
    city: 'Varanasi',
    state: 'Uttar Pradesh',
    cuisine: 'Desserts • Bakery • Beverages',
    address: 'Dashashwamedh Ghat, Varanasi, Uttar Pradesh 221001',
    openingTime: '9:00 AM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/dashashwamedh-sweets-and-chai-vns-cover/1600/900',
    logo: svgLogoDataUri('DSC', '#1f2937', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'babatpur-bakery-and-brews-vns',
    name: 'Babatpur Bakery & Brews',
    city: 'Varanasi',
    state: 'Uttar Pradesh',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Babatpur, Varanasi, Uttar Pradesh 221006',
    openingTime: '8:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/babatpur-bakery-and-brews-vns-cover/1600/900',
    logo: svgLogoDataUri('BBBV', '#a16207', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'dlw-bowl-studio-vns',
    name: 'DLW Bowl Studio',
    city: 'Varanasi',
    state: 'Uttar Pradesh',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'DLW Rd, Varanasi, Uttar Pradesh 221004',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/dlw-bowl-studio-vns-cover/1600/900',
    logo: svgLogoDataUri('DLWB', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'paharia-wok-yard-vns',
    name: 'Paharia Wok Yard',
    city: 'Varanasi',
    state: 'Uttar Pradesh',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'Paharia, Varanasi, Uttar Pradesh 221007',
    openingTime: '12:00 PM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/paharia-wok-yard-vns-cover/1600/900',
    logo: svgLogoDataUri('PWY', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'sarnath-thali-craft-vns',
    name: 'Sarnath Thali Craft',
    city: 'Varanasi',
    state: 'Uttar Pradesh',
    cuisine: 'North Indian • Thali • Vegetarian',
    address: 'Sarnath, Varanasi, Uttar Pradesh 221007',
    openingTime: '11:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/sarnath-thali-craft-vns-cover/1600/900',
    logo: svgLogoDataUri('STC', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },

  // Lucknow (20)
  {
    _id: 'hazratganj-cafe-collective-lko',
    name: 'Hazratganj Cafe Collective',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Hazratganj, Lucknow, Uttar Pradesh 226001',
    openingTime: '8:00 AM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/hazratganj-cafe-collective-lko-cover/1600/900',
    logo: svgLogoDataUri('HCC', '#1d4ed8', '#eff6ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'gomti-nagar-bowl-lab-lko',
    name: 'Gomti Nagar Bowl Lab',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Gomti Nagar, Lucknow, Uttar Pradesh 226010',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/gomti-nagar-bowl-lab-lko-cover/1600/900',
    logo: svgLogoDataUri('GNBL', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'aliganj-wok-street-lko',
    name: 'Aliganj Wok Street',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'Aliganj, Lucknow, Uttar Pradesh 226024',
    openingTime: '12:00 PM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/aliganj-wok-street-lko-cover/1600/900',
    logo: svgLogoDataUri('AWS', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'indira-nagar-grill-room-lko',
    name: 'Indira Nagar Grill Room',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'Grills • BBQ • Continental',
    address: 'Indira Nagar, Lucknow, Uttar Pradesh 226016',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/indira-nagar-grill-room-lko-cover/1600/900',
    logo: svgLogoDataUri('INGR', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'chowk-kebab-room-lko',
    name: 'Chowk Kebab Room',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'Kebabs • Rolls • Mughlai',
    address: 'Chowk, Lucknow, Uttar Pradesh 226003',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/chowk-kebab-room-lko-cover/1600/900',
    logo: svgLogoDataUri('CKR', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'aminabad-thali-house-lko',
    name: 'Aminabad Thali House',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'North Indian • Thali • Vegetarian',
    address: 'Aminabad, Lucknow, Uttar Pradesh 226018',
    openingTime: '11:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/aminabad-thali-house-lko-cover/1600/900',
    logo: svgLogoDataUri('ATH', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'rajajipuram-tiffin-corner-lko',
    name: 'Rajajipuram Tiffin Corner',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'South Indian • Tiffin • Breakfast',
    address: 'Rajajipuram, Lucknow, Uttar Pradesh 226017',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/rajajipuram-tiffin-corner-lko-cover/1600/900',
    logo: svgLogoDataUri('RTC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'charbagh-biryani-atelier-lko',
    name: 'Charbagh Biryani Atelier',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'Biriyani • Mughlai • Kebabs',
    address: 'Charbagh, Lucknow, Uttar Pradesh 226004',
    openingTime: '11:30 AM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/charbagh-biryani-atelier-lko-cover/1600/900',
    logo: svgLogoDataUri('CBA', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'vibhuti-khand-pasta-bar-lko',
    name: 'Vibhuti Khand Pasta Bar',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'Italian • Pizza • Pasta',
    address: 'Vibhuti Khand, Gomti Nagar, Lucknow, Uttar Pradesh 226010',
    openingTime: '12:00 PM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/vibhuti-khand-pasta-bar-lko-cover/1600/900',
    logo: svgLogoDataUri('VKPB', '#0f172a', '#e2e8f0'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'jankipuram-dosa-club-lko',
    name: 'Jankipuram Dosa Club',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'South Indian • Dosa • Breakfast',
    address: 'Jankipuram, Lucknow, Uttar Pradesh 226021',
    openingTime: '7:30 AM',
    closingTime: '2:30 PM',
    image: 'https://picsum.photos/seed/jankipuram-dosa-club-lko-cover/1600/900',
    logo: svgLogoDataUri('JDC', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'hazratganj-sweets-and-chai-lko',
    name: 'Hazratganj Sweets & Chai',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'Desserts • Bakery • Beverages',
    address: 'Hazratganj, Lucknow, Uttar Pradesh 226001',
    openingTime: '9:00 AM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/hazratganj-sweets-and-chai-lko-cover/1600/900',
    logo: svgLogoDataUri('HSC', '#1f2937', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'ashiyana-bakery-and-brews-lko',
    name: 'Ashiyana Bakery & Brews',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Ashiyana, Lucknow, Uttar Pradesh 226012',
    openingTime: '8:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/ashiyana-bakery-and-brews-lko-cover/1600/900',
    logo: svgLogoDataUri('ABBL', '#a16207', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'madiyaon-bowl-studio-lko',
    name: 'Madiyaon Bowl Studio',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Madiyaon, Lucknow, Uttar Pradesh 226020',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/madiyaon-bowl-studio-lko-cover/1600/900',
    logo: svgLogoDataUri('MBS', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'krishna-nagar-wok-yard-lko',
    name: 'Krishna Nagar Wok Yard',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'Krishna Nagar, Lucknow, Uttar Pradesh 226012',
    openingTime: '12:00 PM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/krishna-nagar-wok-yard-lko-cover/1600/900',
    logo: svgLogoDataUri('KNWY', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'alambagh-grill-room-lko',
    name: 'Alambagh Grill Room',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'Grills • BBQ • Continental',
    address: 'Alambagh, Lucknow, Uttar Pradesh 226005',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/alambagh-grill-room-lko-cover/1600/900',
    logo: svgLogoDataUri('AGR', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kakori-kebab-room-lko',
    name: 'Kakori Kebab Room',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'Kebabs • Rolls • Mughlai',
    address: 'Kakori, Lucknow, Uttar Pradesh 226101',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/kakori-kebab-room-lko-cover/1600/900',
    logo: svgLogoDataUri('KKR', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'munsi-pulia-thali-craft-lko',
    name: 'Munsi Pulia Thali Craft',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'North Indian • Thali • Vegetarian',
    address: 'Munsi Pulia, Lucknow, Uttar Pradesh 226016',
    openingTime: '11:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/munsi-pulia-thali-craft-lko-cover/1600/900',
    logo: svgLogoDataUri('MPTC', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'mahanagar-tiffin-corner-lko',
    name: 'Mahanagar Tiffin Corner',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'South Indian • Tiffin • Breakfast',
    address: 'Mahanagar, Lucknow, Uttar Pradesh 226006',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/mahanagar-tiffin-corner-lko-cover/1600/900',
    logo: svgLogoDataUri('MTC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'dubagga-biryani-atelier-lko',
    name: 'Dubagga Biryani Atelier',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'Biriyani • Mughlai • Kebabs',
    address: 'Dubagga, Lucknow, Uttar Pradesh 226003',
    openingTime: '11:30 AM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/dubagga-biryani-atelier-lko-cover/1600/900',
    logo: svgLogoDataUri('DBA', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'nakhas-pasta-bar-lko',
    name: 'Nakhas Pasta Bar',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'Italian • Pizza • Pasta',
    address: 'Nakhas, Lucknow, Uttar Pradesh 226003',
    openingTime: '12:00 PM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/nakhas-pasta-bar-lko-cover/1600/900',
    logo: svgLogoDataUri('NPB', '#0f172a', '#e2e8f0'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kapoorthala-dosa-club-lko',
    name: 'Kapoorthala Dosa Club',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    cuisine: 'South Indian • Dosa • Breakfast',
    address: 'Kapoorthala, Lucknow, Uttar Pradesh 226024',
    openingTime: '7:30 AM',
    closingTime: '2:30 PM',
    image: 'https://picsum.photos/seed/kapoorthala-dosa-club-lko-cover/1600/900',
    logo: svgLogoDataUri('KDC', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },

  // Ranchi (30)
  {
    _id: 'main-road-cafe-collective-rnc',
    name: 'Main Road Cafe Collective',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Main Road, Ranchi, Jharkhand 834001',
    openingTime: '8:00 AM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/main-road-cafe-collective-rnc-cover/1600/900',
    logo: svgLogoDataUri('MRCC', '#1d4ed8', '#eff6ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'morabadi-bowl-lab-rnc',
    name: 'Morabadi Bowl Lab',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Morabadi, Ranchi, Jharkhand 834008',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/morabadi-bowl-lab-rnc-cover/1600/900',
    logo: svgLogoDataUri('MBL', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'lalpur-wok-street-rnc',
    name: 'Lalpur Wok Street',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'Lalpur, Ranchi, Jharkhand 834001',
    openingTime: '12:00 PM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/lalpur-wok-street-rnc-cover/1600/900',
    logo: svgLogoDataUri('LWS', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kanke-road-grill-room-rnc',
    name: 'Kanke Road Grill Room',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Grills • BBQ • Continental',
    address: 'Kanke Road, Ranchi, Jharkhand 834008',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/kanke-road-grill-room-rnc-cover/1600/900',
    logo: svgLogoDataUri('KRGR', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'hindpiri-kebab-room-rnc',
    name: 'Hindpiri Kebab Room',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Kebabs • Rolls • Mughlai',
    address: 'Hindpiri, Ranchi, Jharkhand 834001',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/hindpiri-kebab-room-rnc-cover/1600/900',
    logo: svgLogoDataUri('HKR', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'doranda-thali-house-rnc',
    name: 'Doranda Thali House',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'North Indian • Thali • Vegetarian',
    address: 'Doranda, Ranchi, Jharkhand 834002',
    openingTime: '11:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/doranda-thali-house-rnc-cover/1600/900',
    logo: svgLogoDataUri('DTH', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'harmu-tiffin-corner-rnc',
    name: 'Harmu Tiffin Corner',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'South Indian • Tiffin • Breakfast',
    address: 'Harmu, Ranchi, Jharkhand 834002',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/harmu-tiffin-corner-rnc-cover/1600/900',
    logo: svgLogoDataUri('HTC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kantatoli-biryani-atelier-rnc',
    name: 'Kantatoli Biryani Atelier',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Biriyani • Mughlai • Kebabs',
    address: 'Kantatoli, Ranchi, Jharkhand 834001',
    openingTime: '11:30 AM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/kantatoli-biryani-atelier-rnc-cover/1600/900',
    logo: svgLogoDataUri('KBA', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'hatia-pasta-bar-rnc',
    name: 'Hatia Pasta Bar',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Italian • Pizza • Pasta',
    address: 'Hatia, Ranchi, Jharkhand 834003',
    openingTime: '12:00 PM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/hatia-pasta-bar-rnc-cover/1600/900',
    logo: svgLogoDataUri('HPB', '#0f172a', '#e2e8f0'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'bariatu-dosa-club-rnc',
    name: 'Bariatu Dosa Club',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'South Indian • Dosa • Breakfast',
    address: 'Bariatu, Ranchi, Jharkhand 834009',
    openingTime: '7:30 AM',
    closingTime: '2:30 PM',
    image: 'https://picsum.photos/seed/bariatu-dosa-club-rnc-cover/1600/900',
    logo: svgLogoDataUri('BDC', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'upper-bazar-sweets-and-chai-rnc',
    name: 'Upper Bazar Sweets & Chai',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Desserts • Bakery • Beverages',
    address: 'Upper Bazar, Ranchi, Jharkhand 834001',
    openingTime: '9:00 AM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/upper-bazar-sweets-and-chai-rnc-cover/1600/900',
    logo: svgLogoDataUri('UBSC', '#1f2937', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'argora-bakery-and-brews-rnc',
    name: 'Argora Bakery & Brews',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Argora, Ranchi, Jharkhand 834002',
    openingTime: '8:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/argora-bakery-and-brews-rnc-cover/1600/900',
    logo: svgLogoDataUri('ABBR', '#a16207', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'namkum-bowl-studio-rnc',
    name: 'Namkum Bowl Studio',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Namkum, Ranchi, Jharkhand 834010',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/namkum-bowl-studio-rnc-cover/1600/900',
    logo: svgLogoDataUri('NBS', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'booty-more-wok-yard-rnc',
    name: 'Booty More Wok Yard',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'Booty More, Ranchi, Jharkhand 834008',
    openingTime: '12:00 PM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/booty-more-wok-yard-rnc-cover/1600/900',
    logo: svgLogoDataUri('BMWY', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'ratu-road-grill-room-rnc',
    name: 'Ratu Road Grill Room',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Grills • BBQ • Continental',
    address: 'Ratu Road, Ranchi, Jharkhand 834005',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/ratu-road-grill-room-rnc-cover/1600/900',
    logo: svgLogoDataUri('RRGR', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'tatisilwai-kebab-and-rolls-rnc',
    name: 'Tatisilwai Kebab & Rolls',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Kebabs • Rolls • Street Food',
    address: 'Tatisilwai, Ranchi, Jharkhand 835103',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/tatisilwai-kebab-and-rolls-rnc-cover/1600/900',
    logo: svgLogoDataUri('TKR', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kutchery-road-thali-craft-rnc',
    name: 'Kutchery Road Thali Craft',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'North Indian • Thali • Vegetarian',
    address: 'Kutchery Road, Ranchi, Jharkhand 834001',
    openingTime: '11:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/kutchery-road-thali-craft-rnc-cover/1600/900',
    logo: svgLogoDataUri('KRTC', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'bypass-tiffin-corner-rnc',
    name: 'Bypass Tiffin Corner',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'South Indian • Tiffin • Breakfast',
    address: 'Ring Road, Ranchi, Jharkhand 834008',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/bypass-tiffin-corner-rnc-cover/1600/900',
    logo: svgLogoDataUri('BTC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'tupudana-biryani-atelier-rnc',
    name: 'Tupudana Biryani Atelier',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Biriyani • Mughlai • Kebabs',
    address: 'Tupudana, Ranchi, Jharkhand 834003',
    openingTime: '11:30 AM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/tupudana-biryani-atelier-rnc-cover/1600/900',
    logo: svgLogoDataUri('TBA', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'hb-road-pasta-bar-rnc',
    name: 'HB Road Pasta Bar',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Italian • Pizza • Pasta',
    address: 'HB Road, Ranchi, Jharkhand 834001',
    openingTime: '12:00 PM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/hb-road-pasta-bar-rnc-cover/1600/900',
    logo: svgLogoDataUri('HRPB', '#0f172a', '#e2e8f0'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'firayalal-dosa-club-rnc',
    name: 'Firayalal Dosa Club',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'South Indian • Dosa • Breakfast',
    address: 'Firayalal Chowk, Ranchi, Jharkhand 834001',
    openingTime: '7:30 AM',
    closingTime: '2:30 PM',
    image: 'https://picsum.photos/seed/firayalal-dosa-club-rnc-cover/1600/900',
    logo: svgLogoDataUri('FDC', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'siramtoli-sweets-and-chai-rnc',
    name: 'Siramtoli Sweets & Chai',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Desserts • Bakery • Beverages',
    address: 'Siramtoli, Ranchi, Jharkhand 834001',
    openingTime: '9:00 AM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/siramtoli-sweets-and-chai-rnc-cover/1600/900',
    logo: svgLogoDataUri('SSC', '#1f2937', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'soso-bakery-and-brews-rnc',
    name: 'SoSo Bakery & Brews',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Cafe • Bakery • Desserts',
    address: 'Harmu Road, Ranchi, Jharkhand 834002',
    openingTime: '8:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/soso-bakery-and-brews-rnc-cover/1600/900',
    logo: svgLogoDataUri('SSBB', '#a16207', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'khelgaon-bowl-lab-rnc',
    name: 'Khelgaon Bowl Lab',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Healthy • Bowls • Salads',
    address: 'Khelgaon, Ranchi, Jharkhand 834010',
    openingTime: '10:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/khelgaon-bowl-lab-rnc-cover/1600/900',
    logo: svgLogoDataUri('KBL', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'pandra-wok-street-rnc',
    name: 'Pandra Wok Street',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Pan-Asian • Chinese • Thai',
    address: 'Pandra, Ranchi, Jharkhand 834005',
    openingTime: '12:00 PM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/pandra-wok-street-rnc-cover/1600/900',
    logo: svgLogoDataUri('PWS', '#4c1d95', '#f5f3ff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'kadru-grill-room-rnc',
    name: 'Kadru Grill Room',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Grills • BBQ • Continental',
    address: 'Kadru, Ranchi, Jharkhand 834002',
    openingTime: '12:00 PM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/kadru-grill-room-rnc-cover/1600/900',
    logo: svgLogoDataUri('KGR', '#7c2d12', '#fff7ed'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'bit-mesra-kebab-room-rnc',
    name: 'BIT Mesra Kebab Room',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Kebabs • Rolls • Mughlai',
    address: 'Mesra, Ranchi, Jharkhand 835215',
    openingTime: '4:30 PM',
    closingTime: '1:00 AM',
    image: 'https://picsum.photos/seed/bit-mesra-kebab-room-rnc-cover/1600/900',
    logo: svgLogoDataUri('BMKR', '#9f1239', '#fff1f2'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'hinoo-thali-house-rnc',
    name: 'Hinoo Thali House',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'North Indian • Thali • Vegetarian',
    address: 'Hinoo, Ranchi, Jharkhand 834002',
    openingTime: '11:30 AM',
    closingTime: '10:30 PM',
    image: 'https://picsum.photos/seed/hinoo-thali-house-rnc-cover/1600/900',
    logo: svgLogoDataUri('HTH', '#92400e', '#fffbeb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'tiril-tiffin-corner-rnc',
    name: 'Tiril Tiffin Corner',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'South Indian • Tiffin • Breakfast',
    address: 'Tiril, Ranchi, Jharkhand 834006',
    openingTime: '7:00 AM',
    closingTime: '10:00 PM',
    image: 'https://picsum.photos/seed/tiril-tiffin-corner-rnc-cover/1600/900',
    logo: svgLogoDataUri('TTC', '#111827', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'helpline-biryani-atelier-rnc',
    name: 'Helpline Biryani Atelier',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Biriyani • Mughlai • Kebabs',
    address: 'Ashok Nagar, Ranchi, Jharkhand 834002',
    openingTime: '11:30 AM',
    closingTime: '11:45 PM',
    image: 'https://picsum.photos/seed/helpline-biryani-atelier-rnc-cover/1600/900',
    logo: svgLogoDataUri('HBA', '#0f766e', '#ecfeff'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'science-city-pasta-bar-rnc',
    name: 'Science City Pasta Bar',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Italian • Pizza • Pasta',
    address: 'Bariatu Road, Ranchi, Jharkhand 834009',
    openingTime: '12:00 PM',
    closingTime: '11:00 PM',
    image: 'https://picsum.photos/seed/science-city-pasta-bar-rnc-cover/1600/900',
    logo: svgLogoDataUri('SCPB', '#0f172a', '#e2e8f0'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'station-road-dosa-club-rnc',
    name: 'Station Road Dosa Club',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'South Indian • Dosa • Breakfast',
    address: 'Station Road, Ranchi, Jharkhand 834001',
    openingTime: '7:30 AM',
    closingTime: '2:30 PM',
    image: 'https://picsum.photos/seed/station-road-dosa-club-rnc-cover/1600/900',
    logo: svgLogoDataUri('SRDC', '#065f46', '#ecfdf5'),
    isActive: true,
    taxPercentage: 5
  },
  {
    _id: 'piskanagri-sweets-and-chai-rnc',
    name: 'Piska Nagri Sweets & Chai',
    city: 'Ranchi',
    state: 'Jharkhand',
    cuisine: 'Desserts • Bakery • Beverages',
    address: 'Piska Nagri, Ranchi, Jharkhand 834005',
    openingTime: '9:00 AM',
    closingTime: '11:30 PM',
    image: 'https://picsum.photos/seed/piskanagri-sweets-and-chai-rnc-cover/1600/900',
    logo: svgLogoDataUri('PNSC', '#1f2937', '#f9fafb'),
    isActive: true,
    taxPercentage: 5
  }
];

export function getDummyRestaurantById(id) {
  return DUMMY_RESTAURANTS.find((r) => r._id === id) || null;
}